@let segmentCount = segmentCount$ | async;
<span>{{ segmentCount }} SMS {{ segmentCount === 1 ? 'Segment' : 'Segments' }}</span>
<ng-content />
